/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSDybaseCartesian3D from './msdybasecartesian3d';
import Column3DDataset from '../_internal/datasets/column3d';
import LineDataset from '../_internal/datasets/line';
import Column3DGroup from '../_internal/datasets/groups/column.multiseries';
import datasetFactory from '../_internal/factories/combi-dual-y-3d-dataset';

let UNDEFINED,
  HUNDREDSTRING = '100',
  SEVENTYSTRING = '70';
/**
 * Creates class for MSColumn3DLineDy
 */
class MSColumn3DLineDy extends MSDybaseCartesian3D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'MSColumn3DLineDy';
  }
  /**
   * Constructor function of MSColumn3DLineDy class
   */
  constructor () {
    super();
    this.defaultPlotShadow = 1;
    this.isDual = true;
    this.registerFactory('dataset', datasetFactory, ['vCanvas']);
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'MSColumn3DLineDy';
  }
  /**
   * Sets default configuration of chart elements
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.is3D = true;
    config.sDefaultDatasetType = 'line';
    config.friendlyName = 'Multi-series 3D Column and Line Chart';
    config.defaultDatasetType = 'column3d';
    config.use3dlineshift = 1;
    config.isdual = true;
    config.showplotborder = 0;
    config.enablemousetracking = true;

    config.anchorborderthickness = 1;
    config.anchorimageurl = UNDEFINED;
    config.anchorimagepadding = 1;
    config.anchorsides = 1;
    config.anchoralpha = UNDEFINED;
    config.anchorbgalpha = HUNDREDSTRING;
    config.anchorimagealpha = HUNDREDSTRING;
    config.anchorimagescale = 100;
    config.anchorstartangle = 90;
    config.anchorshadow = 0;
    config.anchorbgcolor = UNDEFINED;
    config.anchorbordercolor = UNDEFINED;
    config.anchorradius = 3;
    config.showvalues = 1;
    config.plotfillalpha = SEVENTYSTRING;
    config.linedashlen = 5;
    config.linedashgap = 4;
    config.linedashed = UNDEFINED;
    config.linealpha = HUNDREDSTRING;
    config.linethickness = 2;
    config.drawfullareaborder = 1;
    config.connectnulldata = 0;
    config.showzeroplaneontop = 0;
  }
  /**
   * This method return the dataset definations for this charts
   * @param  {string} name type of dataset class
   * @return {Object}      dataset class
   */
  getDSdef (name) {
    return name === 'line' ? LineDataset : Column3DDataset;
  }
  /**
   * This method return the dataset-group definations for this charts
   * @param  {string} name is type of dataset group
   * @return {Object} <dataset group class>     dataset group class
   */
  getDSGroupdef (name) {
    return name === 'column3d' ? Column3DGroup : UNDEFINED;
  }

  /**
   * function to return dataset type applicable for this chart
   * @param   {string}  name            dataset type
   * @param   {boolean} secondaryAxis   dataset type for secondary axis
   * @return  {string}                  dataset type applicable for this chart
   */
  getDSType (name, secondaryAxis) {
    return ((name && name.toLowerCase() === 'line') || secondaryAxis) ? 'line' : 'column3d';
  }
}
export default MSColumn3DLineDy;
